module.exports = __webpack_public_path__ + "img/pray.df92997b.png";